import React, { useState, useEffect, useMemo } from 'react';
import { CrudMasterDetailView, GridView, CompositeView, MasterDetailForm, CrudContext, OptionProps } from '@digital/ui';
import { Area, getAllAreas } from '@app/api/area';
import {
  Projeto,
  getProjetoJoinTipoPacote,
  ProjetoJoinPacote,
  ProjetoPacote,
  getAllProjetosFiltroContextoTelaProjeto,
} from '@app/api/projeto';

import { AcronimoProjeto, getAllAcronimosProjeto } from '@app/api/acronimosProjeto';
import { getAllTapHasJoinProjeto, TapCicloOrcamentarioHasJoinProjeto, TapJoinProjeto } from '@app/api/tap';
import { Diretoria, getAllDiretorias } from '@app/api/diretoria';
import { hasPermission } from '@app/helpers/permissions';
import { StatusProjeto, getAllStatusProjeto } from '@app/api/statusProjeto';
import { getAllTiposProjetoFase, TipoProjetoFase } from '@app/api/tipoProjetoFase';
import { Departamento, getAllDepartamento } from '../../api/departamento';
import { Usuario, getAllUsuariosPorPerfil } from '../../api/usuario';
import FormDadosProjeto from './FormDadosProjeto';
import FormAcronimoProjeto from './FormAcronimoProjeto';
import FormResponsaveisProjeto from './FormResponsaveisProjeto';
import FormTapCicloOrcamentario from './FormTapCicloOrcamentario';
import FormProjetoPacote from './FormProjetoPacote';
import FormTableOrcadoCapexProjeto from './FormTableOrcadoCapexProjeto';
import FormTableOrcadoRfaProjeto from './FormTableOrcadoRfaProjeto';
import FormTableOrcadoAnoProjeto from './FormTableOrcadoAnoProjeto';
import FormTableRequisitadoProjeto from './FormTableRequisitadoProjeto';
import FormTableResumoContratado from './FormTableResumoContratado';
import FormAContratar from './FormAContratar';
import FormADistribuir from './FormADistribuir';

import { AcronimoPacote, getAllAcronimosPacote } from '@app/api/acronimosPacote';
import {
  OrcamentoAcronimoPacote,
  getAllResumoPlanilhaCapexProjeto,
  ResumoCapex,
  ResumoRfa,
  getAllResumoPlanilhaRfaProjeto,
  getAllResumoPlanilhaAnoProjeto,
  ResumoAnoMes,
  OrcadoAnoMes,
} from '@app/api/ordemInvestimento';
import { updateOrdemByAcronimoPacote } from '@app/api/tipoPacote';
import { StatusRfa, getAllStatusRfa } from '@app/api/statusRfa';
import { getAllTipoDistribuicaoForcastOptions } from '@app/api/tipoDistribuicaoForcast';
import { TipoOptions } from '@app/api/api';
import { getAllDisciplicaProjetos } from '@app/api/disciplicaProjetos';

const ProjetoComponent = () => {
  const [areas, setAreas] = useState<Area[]>();
  const [diretorias, setDiretorias] = useState<Diretoria[]>();
  const [acronimos, setAcronimos] = useState<AcronimoProjeto[]>();
  const [departamentos, setDepartamentos] = useState<Departamento[]>();
  const [statusList, setStatusList] = useState<StatusProjeto[]>();
  const [statusRfa, setStatusRfa] = useState<StatusRfa[]>();
  const [fasesList, setFasesList] = useState<TipoProjetoFase[]>();
  const [usuarios, setUsuarios] = useState<Usuario[]>();
  const [projetos, setProjetos] = useState(() => getAllProjetosFiltroContextoTelaProjeto);
  const [tap, setTap] = useState<TapCicloOrcamentarioHasJoinProjeto[]>();
  const [projetoSelecionado, setProjetoSelectionado] = useState<Projeto>();
  const [projetoPacote, setProjetoPacote] = useState<ProjetoPacote[]>();
  const [acronimosPacotes, setAcronimosPacotes] = useState<AcronimoPacote[]>();
  const [resumoCapex, setResumoCapex] = useState<ResumoCapex[]>();
  const [resumoRfa, setResumoRfa] = useState<ResumoRfa[]>();
  const [resumoAno, setResumoAno] = useState<ResumoAnoMes[]>();
  const [resultTableAnoMes, setResultTableAnoMes] = useState<OrcadoAnoMes>();








  const [tipoDistribuicaoForcast, setTipoDistribuicaoForcast] = useState<OptionProps[]>();
  const [projetoDisciplina, setProjetoDisciplina] = useState<TipoOptions[]>();


  useEffect(() => {
    const getUsuariosData = async () => {
      const result = await getAllUsuariosPorPerfil(7);
      if (result) setUsuarios(result);
    };

    const getTipoDistribuicaoForcast = async () => {
      const result = await getAllTipoDistribuicaoForcastOptions();
      if (result) setTipoDistribuicaoForcast(result);
    };

    const getDiretoriasData = async () => {
      const result = await getAllDiretorias();
      if (result) setDiretorias(result);
    };

    const getAreasData = async () => {
      const result = await getAllAreas();
      if (result) setAreas(result);
    };

    const getDepartamentosData = async () => {
      const result = await getAllDepartamento();
      if (result) setDepartamentos(result);
    };

    const getAcronimosData = async () => {
      const result = await getAllAcronimosProjeto();
      if (result) setAcronimos(result);
    };

    const getStatusData = async () => {
      const result = await getAllStatusProjeto();
      if (result) setStatusList(result);
    };

    const getStatusRfa = async () => {
      const result = await getAllStatusRfa();
      if (result) setStatusRfa(result);
    };

    const getFasesData = async () => {
      const result = await getAllTiposProjetoFase();
      if (result) setFasesList(result);
    };

    const getAcronimosPacotes = async () => {
      const result = await getAllAcronimosPacote();
      if (result) setAcronimosPacotes(result);
    };

    const getProjetoDisciplinas = async () => {
      const result = await getAllDisciplicaProjetos();
      if (result) {

        setProjetoDisciplina(result);
      }
    }

    getUsuariosData();
    getDiretoriasData();
    getAreasData();
    getDepartamentosData();
    getAcronimosData();
    getStatusData();
    getStatusRfa();
    getFasesData();
    getAcronimosPacotes();
    getTipoDistribuicaoForcast();
    getProjetoDisciplinas();
  }, []);

  useEffect(() => {
    if (projetoSelecionado) {
      const join: TapJoinProjeto = {
        projetoId: projetoSelecionado.id,
        cicloOrcamentarioId: '',
      };

      const getTapData = async (t: TapJoinProjeto) => {
        const result = await getAllTapHasJoinProjeto(t);
        if (result) {
          setTap(result);
        }
      };

      getTapData(join);
    }
  }, [projetoSelecionado]);

  const [refazerFuncao, setRefazerFuncao] = useState(false);
  let fn = () => { };

  useMemo(() => {
    fn = () => { return `${{ ...projetoSelecionado }}` };
  }, [refazerFuncao])

  useEffect(() => {

    setRefazerFuncao(!refazerFuncao);
    window.addEventListener('beforeunload', fn);
  }, [projetoSelecionado])

  useEffect(() => {
    if (projetoSelecionado) {
      const join: ProjetoJoinPacote = {
        id: projetoSelecionado.id,
      };

      const getProjetoJoinPacoteData = async (t: ProjetoJoinPacote) => {
        const result = await getProjetoJoinTipoPacote(t);
        if (result) {
          setProjetoPacote(result);
        }
      };

      getProjetoJoinPacoteData(join);
    }
  }, [projetoSelecionado, acronimosPacotes]);

  useEffect(() => {
    if (projetoSelecionado) {
      const getResumoCapex = async (id: string) => {
        const result = await getAllResumoPlanilhaCapexProjeto(id);
        if (result) setResumoCapex(result);
      };

      const getResumoRfa = async (id: string) => {
        const result = await getAllResumoPlanilhaRfaProjeto(id);
        if (result) setResumoRfa(result);
      };

      const getResumoAno = async (id: string) => {
        const result = await getAllResumoPlanilhaAnoProjeto(id);
        if (result) {
          setResultTableAnoMes(result);
          setResumoAno(result.resultDataTabel);
        }
      };
      getResumoCapex(projetoSelecionado.id);
      getResumoRfa(projetoSelecionado.id);
      getResumoAno(projetoSelecionado.id);

    }
  }, [projetoSelecionado]);

  const handleUpdate = async (t: OrcamentoAcronimoPacote) => {
    if (t) {
      const result = await updateOrdemByAcronimoPacote(t);
      if (result) {
        listarAcronimosPacotes();
      }
    }
  };

  const listarAcronimosPacotes = async () => {
    setAcronimosPacotes([]);
    const result = await getAllAcronimosPacote();
    if (result) setAcronimosPacotes(result);
  };

  const handler = async () => {
    setProjetos(() => Promise.resolve(undefined));
    setProjetos(() => getAllProjetosFiltroContextoTelaProjeto);
  };


  const atualizarItens = () => {
    setProjetos(() => Promise.resolve(undefined));
    setProjetos(() => getAllProjetosFiltroContextoTelaProjeto);
  }

  return (
    <CrudMasterDetailView
      getAllItems={projetos}
      disableNotification
      icon="editing-overview_pages_1"
      detailTitleExtractor={item => `${item.codigo} - ${item.nome} - ${item.statusNome}`}
      filterPredicate={(item, value) =>
        item.nome.toLowerCase().includes(value.toLowerCase()) ||
        (item.codigo && item.codigo.toLowerCase().includes(value.toLowerCase())) ||
        (item.statusNome && item.statusNome.toLowerCase().includes(value.toLowerCase())) ||
        item.numero.toLowerCase().includes(value.toLowerCase())
      }
      titleExtractor={item => `${item.codigo} - ${item.nome}`}
      descriptionExtractor={item => item.statusNome || ''}>
      <CrudContext.Consumer>
        {({ selectedItem }) => {
          setProjetoSelectionado(selectedItem);
          return (

            <CompositeView>
              {hasPermission(['Dono', 'PROJETO_ABA_GERAL_VISUALIZAR_ABA']) ? (
                <GridView icon="editing-overview_pages_1" id="geral" noform title="GERAL">
                  <>
                    <MasterDetailForm>
                      <FormDadosProjeto
                        selectedItem={selectedItem}
                        statusList={statusList || []}
                        fasesList={fasesList || []}
                        projetoUpdate={projetoSelecionado || selectedItem}
                        statusRfaList={statusRfa || []}
                        handler={handler}
                      />
                      <FormAcronimoProjeto
                        selectedItem={selectedItem}
                        acronimos={acronimos || []}
                        projetoDisciplina={projetoDisciplina || []}
                      />
                      <FormResponsaveisProjeto
                        selectedItem={selectedItem}
                        usuarios={usuarios || []}
                        areas={areas || []}
                        diretorias={diretorias || []}
                        departamentos={departamentos || []}
                      />
                    </MasterDetailForm>
                  </>
                </GridView>
              ) : (
                () => { }
              )}
              {hasPermission(['Dono', 'PROJETO_ABA_TAP_VISUALIZAR']) ? (
                <GridView icon="ecommerce-attention" id="tap" noform title="TAP">
                  <>
                    {tap &&
                      tap.map(t => (
                        <FormTapCicloOrcamentario
                          key={t.tapAno}
                          areas={areas || []}
                          departamentos={departamentos || []}
                          diretorias={diretorias || []}
                          tapDiretoriaId={t.tapDiretoriaId}
                          tapDepartamentoId={t.tapDepartamentoId}
                          tapAreaId={t.tapAreaId}
                          tapEscopoAnual={t.tapEscopoAnual}
                          tapAno={t.tapAno}
                          tapId={t.tapId}
                          initialValues={t}
                          keyId={t.tapId}
                        />
                      ))}
                  </>
                </GridView>
              ) : (
                () => { }
              )}
              {hasPermission(['Dono', 'PROJETO_ABA_PACOTES_VISUALIZAR']) ? (
                <GridView icon="ecommerce-box" id="pacotesss" noform title="Pacotes">
                  <FormProjetoPacote
                    acronimos={
                      acronimosPacotes && acronimosPacotes.map(a => ({ text: a.sigla, value: a.id.toString() }))
                    }
                    projetoPa={projetoPacote || []}
                    handleUpdate={handleUpdate}
                  />
                </GridView>
              ) : (
                () => { }
              )}
              {hasPermission(['Dono', 'PROJETO_ABA_ORCADO_VISUALIZAR']) ? (
                <GridView icon="business-estimate" id="Orcado" noform title="Orçado">
                  <FormTableOrcadoCapexProjeto
                    resumoCapex={resumoCapex || []}
                    projetoId={(projetoSelecionado && projetoSelecionado.id) || ''}
                  />
                  <FormTableOrcadoRfaProjeto
                    resumoRfa={resumoRfa || []}
                    projetoId={(projetoSelecionado && projetoSelecionado.id) || ''}
                  />
                  <FormTableOrcadoAnoProjeto
                    resumoAno={resumoAno || []}
                    resultTableAnoMes={resultTableAnoMes || ({} as OrcadoAnoMes)}
                    projetoId={(projetoSelecionado && projetoSelecionado.id) || ''}
                  />
                </GridView>
              ) : (
                () => { }
              )}
              {hasPermission(['Dono', 'PROJETO_ABA_ORCADO_VISUALIZAR']) && selectedItem ? (
                <GridView icon="messaging-send_file" id="requisitado" noform title="Requisitado">
                  <FormTableRequisitadoProjeto
                    projetoId={selectedItem.id}
                  />
                </GridView>
              ) : (
                () => { }
              )}
              {hasPermission(['Dono', 'PROJETO_ABA_ORCADO_VISUALIZAR']) && selectedItem ? (
                <GridView icon="business-agreement" id="contratado" noform title="Contratado">
                  <FormTableResumoContratado
                    projetoId={selectedItem.id}
                  />
                </GridView>
              ) : (
                () => { }
              )}

              {hasPermission(['Dono', 'PROJETO_ABA_ORCADO_VISUALIZAR']) && selectedItem ? (
                <GridView icon="files-new_by_copy" id="aContratar" noform title="A CONTRATAR">
                  <FormAContratar selectedItem={selectedItem} />
                </GridView>
              ) : (
                () => { }
              )}

              {hasPermission(['Dono', 'PROJETO_ABA_ORCADO_VISUALIZAR'])
                && selectedItem
                && tipoDistribuicaoForcast ? (
                <GridView icon="business-accounting" id="aDistribuir" noform title="A DISTRIBUIR">
                  <FormADistribuir
                    selectedItem={selectedItem}
                    listTipoDistribuicaoForcast={tipoDistribuicaoForcast} />
                </GridView>
              ) : (
                () => { }
              )}
            </CompositeView>

          );
        }}
      </CrudContext.Consumer>
    </CrudMasterDetailView>
  );
};

export default ProjetoComponent;
